import { all } from 'redux-saga/effects';
import requests from './requests';

export const requestsSaga = function* root() {
  yield all([requests()]);
};
